import React, { Component, Fragment } from "react";
import moment from "moment";

import { clientService, projectService, selectService, userService } from "services";
import { datePickerProps, dateFormat, formatter, selectProps } from "utils";
import { Button, Icon, Select, Input, DatePicker, Slider, Spin, Checkbox } from "antd";

// Filtres unifiés pour la page de dashboard.
// Retourne un {} contenant les filtres sélectionnés au composant
// parent (par l'entremise de props.handleSubmit(___))
class Filters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {},
      selects: {},

      loading: true,
      edited: false,
      opened: false,
    };

    this.handleOpenedToggle = this.handleOpenedToggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleListChangeBatch = this.handleListChangeBatch.bind(this);
    this.handleListChange = this.handleListChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClear = this.handleClear.bind(this);
  }

  componentDidMount() {
    var defaultFilters = { ...this.props.defaultFilters };

    // Logique pour le date picker.
    if ("date" in defaultFilters)
      defaultFilters.date = (defaultFilters.date || []).map((d) => moment(d));

    this.setState({ filters: defaultFilters || {} }, () => {
      // Fetch les selects.
      this.fetchSelects();
    });
  }

  // Fetch les selects de la page.
  async fetchSelects() {
    const selects = await selectService.listForPage("dashboard");
    const projects = await projectService.list();
    const clients = await clientService.list();
    const users = await userService.list();

    this.setState({
      loading: false,
      selects: {
        ...selects,
        Project: projects,
        Client: clients,
        User: users,
      },
    });
  }

  // Remplit les options des selects en fonction d'une clé donnée.
  fillSelect(key) {
    const { selects } = this.state;
    const options = (selects[key] || []).map((o) => (
      <Select.Option key={o.id} value={o.id}>
        {o.label || o.name}
      </Select.Option>
    ));

    return options;
  }

  handleOpenedToggle() {
    this.setState({ opened: !this.state.opened });
  }

  // Handle le change d'un filtre.
  handleChange(value, key) {
    let filters = { ...this.state.filters };
    if (key == "vacant" && !value) delete filters.vacant;
    this.setState({ filters: { ...filters, [key]: value }, edited: true });
  }

  handleListChange(key, value, force = false, callback = () => {}) {
    const filters = { ...this.state.filters };
    filters[key] = filters[key] || [];

    const index = filters[key].indexOf(value);
    if (force) {
      if (index === -1) filters[key].push(value);
    } else {
      if (index >= 0) filters[key].splice(index, 1);
      else filters[key].push(value);
    }
    this.setState({ filters, edited: true }, callback);
  }

  handleListChangeBatch(key, values = [], add, callback = () => {}) {
    const filters = { ...this.state.filters };
    filters[key] = filters[key] || [];

    if (add) {
      values.forEach((value) => {
        if (!filters[key].includes(value)) filters[key].push(value);
      });
    } else {
      filters[key] = filters[key].filter((value) => values.indexOf(value) === -1);
    }

    this.setState({ filters, edited: true }, callback);
  }

  // Handle le submit des filtres, et passe le tout au composant parent.
  handleSubmit() {
    var filters = { ...this.state.filters };

    // Logique pour le date picker.
    if ("date" in filters) {
      filters.date = (filters.date || []).map((d) => d.format("YYYY-MM-DD"));
      if (filters.date[0] == filters.date[1]) {
        filters.date = [filters.date[0]];
      }
    }

    // Logique finale.
    this.props.handleSubmit(filters);
    this.setState({ edited: false, opened: false });
  }

  // Handle le clear de filtres, et notifie le composant parent.
  handleClear() {
    this.setState({ filters: {} }, () => {
      this.props.handleSubmit(this.state.filters);
      this.setState({ edited: false, opened: false });
    });
  }

  render() {
    const { selects, filters, edited, loading, opened } = this.state;

    // Compteur des filtrs actifs.
    var filtersCount = 0;
    for (var f in filters) {
      if (filters[f] && filters[f] !== "" && filters[f].length > 0) filtersCount++;
    }

    const renderSelect = (key, select, label) => {
      const options = selects[select] || [];
      return (
        <Select
          {...selectProps()}
          size="small"
          onChange={(val) => this.handleChange(val, key)}
          value={filters[key]}
          mode="multiple"
          maxTagCount={0}
          maxTagPlaceholder={(filters[key] || []).length}
        >
          {options.map((option, i) => (
            <Select.Option key={i} value={option.id}>
              {label ? label(option) : option.label}
            </Select.Option>
          ))}
        </Select>
      );
    };

    return (
      <div className="dashboard-filters">
        <Spin spinning={loading}>
          <h2 onClick={this.handleOpenedToggle}>
            <b>{filtersCount}</b>
            Filtres
            <Icon type={opened ? "caret-up" : "caret-down"} />
            {edited && !opened && (
              <span className="warning">
                Attention, certains filtres furent modifiés, mais pas appliqués!
              </span>
            )}
          </h2>
          <div className={"form-wrap" + (opened ? " opened" : "")}>
            <div className="ctn">
              <label>Projets :</label>
              {renderSelect("project_id", "Project", (p) => `[${p.code}] ${p.label}`)}
            </div>

            <div className="ctn">
              <label>Utilisateurs :</label>
              {renderSelect("user_id", "User", (u) => `${u.name} ${u.surname}`)}
            </div>

            <div className="ctn">
              <label>Types de projet :</label>
              {renderSelect("project_type_id", "ProjectType")}
            </div>

            <div className="ctn">
              <label>Clients :</label>
              {renderSelect("client_id", "Client", (c) => c.name)}
            </div>

            <div className="ctn">
              <label>Période :</label>
              <DatePicker.RangePicker
                {...datePickerProps()}
                size="small"
                value={(filters.date || []).map((d) => (d ? moment(d) : null))}
                onChange={(dates, datesString) => this.handleChange(dates, "date")}
              />
            </div>

            <div className="filters-buttons">
              <Button type="link" onClick={this.handleClear}>
                Réinitialiser les filtres
              </Button>
              <Button type="primary" onClick={this.handleSubmit} disabled={!edited}>
                Appliquer les filtres
              </Button>
            </div>
          </div>
        </Spin>
      </div>
    );
  }
}

export default Filters;
